import Recommendations from './recommendations';

export default Recommendations;
